import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import ValidatedInput from "../common/ValidatedInput";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval, noOfChannels } = formData;
  const { setFormData } = useContext(FormDataContext);
  const availableContent = [
    { label: t("symantecses.subscribe.content_events"), value: "events" },
    { label: t("symantecses.subscribe.content_incidents"), value: "incidents" }
  ];
  const [contentTypes, setContentTypes] = useState("");
  const [contentTypeVal, setContentTypeVal] = useState(false);
  const { checkpointIntervalSeconds, streamGUID } = formData;
  const contentArray = contentTypes.split(",");
  const handleSubmit = () => {
    const isPresent = contentArray.includes("events");
    let error = false;
    formData.contentTypes.value = contentTypes;
    if (isPresent && streamGUID.value === " ") {
      setFormError({
        full_message: t("symantecses.subscribe.guid_required_message"),
        nice_message: t("symantecses.subscribe.guid_required")
      });
      error = true;
    }
    if (contentTypes.length === 0) {
      setContentTypeVal(true);
      error = true;
    }
    if (checkpointIntervalSeconds.value < 5) {
      setFormError({
        full_message: t("symantecses.subscribe.checkpoint_message"),
        nice_message: t("symantecses.subscribe.min_checkpoint_interval")
      });
      error = true;
    }
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: t("symantecses.subscribe.invalid_polling_interval_message"),
        nice_message: t("symantecses.subscribe.min_polling_interval")
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };
  const handleContentType = (val) => {
    const value = { value: val, dirty: false };
    setFormData("logTypes", value);
    setContentTypes(val);
    setContentTypeVal(false);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("symantecses.subscribe.log_types_label")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "content_type",
        id: "contentTypes",
        onChange: handleContentType,
        options: availableContent,
        value: contentTypes || ""
      }
    ),
    contentTypeVal && contentTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes" }, t("symantecses.subscribe.select_at_least_one")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("symantecses.subscribe.log_types_help")),
    contentArray.includes("events") && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "streamGUID",
        type: "text",
        onChange,
        fieldData: formData.streamGUID,
        label: t("symantecses.subscribe.stream_guid"),
        help: t("symantecses.subscribe.stream_guid_help"),
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "noOfChannels",
        name: "noOfChannels",
        type: "number",
        value: noOfChannels.value || noOfChannels.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("symantecses.subscribe.number_of_channels_help"),
        label: t("symantecses.subscribe.number_of_channels")
      }
    )),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("symantecses.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "checkpointIntervalSeconds",
        name: "checkpointIntervalSeconds",
        type: "number",
        value: checkpointIntervalSeconds.value || checkpointIntervalSeconds.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("symantecses.subscribe.checkpoint_interval_help"),
        label: t("symantecses.subscribe.checkpoint_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, selectedContentTypes: contentTypes })
  );
};
export default StepSubscribe;
